// extracted by mini-css-extract-plugin
export var messageSideLeft = "_np-1";
export var messageSideRight = "_np-2";
export var orderLookupBubbleContainer = "_np-0";
export var submitButton = "_np-3";